import { render } from "./InboxDrawer.vue?vue&type=template&id=6b4d5735&scoped=true"
import script from "./InboxDrawer.vue?vue&type=script&lang=js"
export * from "./InboxDrawer.vue?vue&type=script&lang=js"

import "./InboxDrawer.vue?vue&type=style&index=0&id=6b4d5735&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4d5735"]])

export default __exports__